// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4609":"31d6cfe0","5228":"a43a7b5a","5699":"a666c149","6365":"ad4b5943","6420":"7f961952"}[chunkId] + ".chunk.css";
};